export default {
    toggleDarkMode: (context) => {
        context.commit('toggleDarkMode');
    },
    toggleMenuSidebar: (context) => {
        context.commit('toggleMenuSidebar');
    },
    toggleControlSidebar: (context) => {
        context.commit('toggleControlSidebar');
    },
    setWindowSize: (context, payload) => {
        context.commit('setWindowSize', payload);
    },
    setNavbarVariant: (context, payload) => {
        context.commit('setNavbarVariant', payload);
    },
    setSidebarSkin: (context, payload) => {
        context.commit('setSidebarSkin', payload);
    }
};
